import debounce from 'lodash.debounce';
import * as React from 'react';

import TextField from '@material-ui/core/TextField';

import { IProps } from './interfaces';

import styles from './TextInput.module.styl';

//Do not use that field when you don't need to send value to api
class TextInput extends React.Component<IProps, any> {
  private readonly applyChanges: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      value: props.input.value,
      propsValue: props.input.value,
    };

    this.applyChanges = debounce(this.props.input.onChange, 300);
  }

  //ABOUT: a static method that is called just before render, causes a side effect
  //FTD-2712 case 3: if there are multiple words and we use space in between,
  //the space gets cancelled automatically
  static getDerivedStateFromProps(props: IProps, state: any) {
    if (
      state.value !== props.input.value &&
      state.propsValue !== props.input.value
    ) {
      return {
        value: props.input.value,
        propsValue: props.input.value,
      };
    }

    return {
      propsValue: props.input.value,
    };
  }

  public render() {
    const { disabled, input, meta, title, type, InputProps } = this.props;
    const { value } = this.state;

    return (
      <div className={styles.root}>
        <TextField
          id={`outlined-with-placeholder${input.name}`}
          label={title}
          placeholder={title}
          disabled={disabled}
          margin="normal"
          onChange={this.onChange}
          variant="outlined"
          fullWidth={true}
          value={value}
          type={type}
          autoComplete="off"
          InputProps={InputProps}
        />

        {meta.touched && meta.error && (
          <span className={styles.error}>{meta.error}</span>
        )}
      </div>
    );
  }

  private onChange = (e: any) => {
    const { normalizer } = this.props;

    const newValue = normalizer ? normalizer(e.target.value) : e.target.value;

    this.setState(
      {
        value: newValue,
      },
      () => this.applyChanges(newValue),
    );
  };
}

export default TextInput;
